export default function ResultsListItem({ children }) {

    return(
        <div className={'results-list-item'} >
            { children }
        </div>
    );
}
